// YT Video lazy loading
document.addEventListener("DOMContentLoaded", function () {
  function initializeVideoPlaceholders() {
    const placeholders = document.querySelectorAll(".zpa-video__wrapper");
    
    placeholders.forEach((placeholder) => {
      // Check if this wrapper already has been processed
      if (placeholder.getAttribute("data-processed") === "true") {
        return;
      }
      
      // Remove existing iframe if any
      const existingIframe = placeholder.querySelector("iframe");
      if (existingIframe) {
        // Get the video ID from the src attribute
        const src = existingIframe.getAttribute("src");
        let videoId;
        
        // Extract video ID from YouTube URL
        if (src) {
          // Handle different YouTube URL formats
          if (src.includes("embed/")) {
            videoId = src.split("embed/")[1].split("?")[0];
          } else if (src.includes("v=")) {
            videoId = src.split("v=")[1].split("&")[0];
          }
        }
        
        // If no videoId found or no data-id attribute, use the one from the wrapper
        if (!videoId) {
          videoId = placeholder.getAttribute("data-id");
        }
        
        if (videoId) {
          // Remove the iframe
          existingIframe.remove();
          
          // Create a thumbnail image as a placeholder
          const thumbnail = document.createElement("img");
          thumbnail.src = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
          thumbnail.alt = "Video Thumbnail";
          thumbnail.style.width = "100%";
          thumbnail.style.cursor = "pointer";
          thumbnail.classList.add("video-thumbnail");
          
          // Add a play button overlay
          const playButton = document.createElement("div");
          playButton.innerHTML = "▶️";
          playButton.style.position = "absolute";
          playButton.style.top = "50%";
          playButton.style.left = "50%";
          playButton.style.transform = "translate(-50%, -50%)";
          playButton.style.fontSize = "3rem";
          playButton.style.color = "white";
          playButton.style.background = "rgba(0, 0, 0, 0.6)";
          playButton.style.borderRadius = "50%";
          playButton.style.padding = "10px";
          
          // Style wrapper for positioning
          const wrapper = document.createElement("div");
          wrapper.style.position = "relative";
          wrapper.style.width = "100%";
          wrapper.style.aspectRatio = "16/9";
          wrapper.style.overflow = "hidden";
          wrapper.appendChild(thumbnail);
          wrapper.appendChild(playButton);
          
          // Store original iframe src to use when clicked
          let originalSrc = src;
          
          // Parse the original URL parameters to preserve them
          let params = {};
          if (originalSrc && originalSrc.includes('?')) {
            const paramString = originalSrc.split('?')[1];
            paramString.split('&').forEach(param => {
              const [key, value] = param.split('=');
              params[key] = value;
            });
          }
          
          // Click event to load video
          wrapper.addEventListener("click", function () {
            const newIframe = document.createElement("iframe");
            
            // Ensure autoplay is set to 1
            params.autoplay = "1";
            
            // Rebuild the URL with parameters
            let videoSrc;
            if (originalSrc) {
              videoSrc = originalSrc.split('?')[0] + '?';
              for (const [key, value] of Object.entries(params)) {
                videoSrc += `${key}=${value}&`;
              }
              videoSrc = videoSrc.slice(0, -1); // Remove trailing &
            } else {
              videoSrc = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
            }
            
            newIframe.setAttribute("src", videoSrc);
            newIframe.setAttribute("frameborder", "0");
            newIframe.setAttribute("allowfullscreen", "1");
            newIframe.setAttribute("allow", "autoplay; encrypted-media");
            newIframe.setAttribute("title", "YouTube video player");
            newIframe.style.width = "100%";
            newIframe.style.height = "100%";
            newIframe.style.position = "absolute";
            newIframe.style.top = "0";
            newIframe.style.left = "0";
            
            placeholder.innerHTML = "";
            placeholder.appendChild(newIframe);
          });
          
          placeholder.innerHTML = "";
          placeholder.appendChild(wrapper);
          placeholder.setAttribute("data-processed", "true");
        }
      } else {
        // Handle case where there is no iframe but has data-id
        const videoId = placeholder.getAttribute("data-id");
        if (videoId) {
          // Create a thumbnail image as a placeholder
          const thumbnail = document.createElement("img");
          thumbnail.src = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
          thumbnail.alt = "Video Thumbnail";
          thumbnail.style.width = "100%";
          thumbnail.style.cursor = "pointer";
          thumbnail.classList.add("video-thumbnail");
          
          // Add a play button overlay
          const playButton = document.createElement("div");
          playButton.innerHTML = "▶️";
          playButton.style.position = "absolute";
          playButton.style.top = "50%";
          playButton.style.left = "50%";
          playButton.style.transform = "translate(-50%, -50%)";
          playButton.style.fontSize = "3rem";
          playButton.style.color = "white";
          playButton.style.background = "rgba(0, 0, 0, 0.6)";
          playButton.style.borderRadius = "50%";
          playButton.style.padding = "10px";
          
          // Style wrapper for positioning
          const wrapper = document.createElement("div");
          wrapper.style.position = "relative";
          wrapper.style.width = "100%";
          wrapper.style.aspectRatio = "16/9";
          wrapper.style.overflow = "hidden";
          wrapper.appendChild(thumbnail);
          wrapper.appendChild(playButton);
          
          // Click event to load video
          wrapper.addEventListener("click", function () {
            const newIframe = document.createElement("iframe");
            newIframe.setAttribute("src", `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`);
            newIframe.setAttribute("frameborder", "0");
            newIframe.setAttribute("allowfullscreen", "1");
            newIframe.setAttribute("allow", "autoplay; encrypted-media");
            newIframe.setAttribute("title", "YouTube video player");
            newIframe.style.width = "100%";
            newIframe.style.height = "100%";
            newIframe.style.position = "absolute";
            newIframe.style.top = "0";
            newIframe.style.left = "0";
            
            placeholder.innerHTML = "";
            placeholder.appendChild(newIframe);
          });
          
          placeholder.innerHTML = "";
          placeholder.appendChild(wrapper);
          placeholder.setAttribute("data-processed", "true");
        }
      }
    });
  }
  
  function lazyLoadVideos() {
    if ("IntersectionObserver" in window) {
      const videoContainers = document.querySelectorAll(".zpa-video__wrapper");
      
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // Mark this video section as visible
              entry.target.setAttribute("data-loaded", "true");
              observer.unobserve(entry.target); // Stop observing after it becomes visible
            }
          });
        },
        {
          rootMargin: "200px 0px", // Load when 200px close to viewport
          threshold: 0.1,
        }
      );
      
      videoContainers.forEach((container) => observer.observe(container));
    }
  }
  
  // Initialize placeholders and lazy loading
  initializeVideoPlaceholders();
  lazyLoadVideos();
});